import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';

class FormElementError extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return (
            <label className="FormElementError">{this.props.error}</label>
        );
    }
}

FormElementError.propTypes = {
    error: PropTypes.string.isRequired
};

FormElementError.defaultProps = {
    error: 'Please enter a valid value.'
};

export default FormElementError;



// WEBPACK FOOTER //
// ./frontend/src/js/components/form/FormElementError.jsx